module.exports = __webpack_public_path__ + "static/assets/c2aa3dbd949d26b464829c369ce31e7c.svg";